module.exports = __webpack_public_path__ + "static/media/git.723bd090.png";